import type { UsuarioTipo } from '@/types/api'

export function isGestor(tipo: UsuarioTipo): boolean {
  return tipo === 'Master' || tipo === 'Admin'
}

export function isMaster(tipo: UsuarioTipo): boolean {
  return tipo === 'Master'
}
